import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]
  static values = {
    speed: { type: Number, default: 1.2 }
  }

  connect () {
    this.onScroll = this.onScroll.bind(this)
    document.addEventListener("scroll", this.onScroll)
    this.updatePosition()
  }

  disconnect () {
    document.removeEventListener("scroll", this.onScroll)
  }

  onScroll () {
    this.updatePosition()
  }

  updatePosition () {
    const scrollTop = window.scrollY
    const offset = scrollTop * this.speedValue
    const isMobile = window.innerWidth <= 768

    this.itemTargets.forEach((item) => {
      if (isMobile) {
        item.style.transform = `translateY(${-offset}px) scale(0.5)`
      } else {
        item.style.transform = `translateY(${-offset}px)`
      }
    })
  }
}
